
import NewApiService from "@/utils/new.api.service";

export default {
    leftNav(context) {
        context.commit("setLoading", true);
        return new Promise((resolve, reject) => {
            NewApiService.get("middleware/left-nav", {})
                .then(({ data }) => {
                    context.commit("setLeftNav", data);
                    context.commit("setLoading", false);
                    //resolve(data);
                })
                .catch(({ response }) => {
                    context.commit("setLoading", false);
                    reject(response)
                });
        });
    },
}
